import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { Divider, Form, Input } from "antd"

const SectionTwoManduUser = (props) => {
  const { currentData } = props
  const { getFieldDecorator } = props.form
  return (
    <Fragment>
      <Divider style={{ margin: "1rem -24px", width: "calc(100% + 48px)" }} />
      <div
        className="ManduUserDrawerComponent-FormNew-section"
        style={{ maxWidth: "100%" }}>
        <div>
          <h4>Nombre y Apellido</h4>
        </div>
        <div>
          <Input.Group compact>
            <Form.Item style={{ width: "33.3%" }}>
              {getFieldDecorator("first_name", {
                initialValue: currentData.first_name,
                rules: [
                  {
                    required: true,
                    message: formLabelMessage("es", "required"),
                  },
                ],
              })(
                <Input
                  maxLength={80}
                  onChange={(e) =>
                    props.setStateForm("first_name", e.target.value)
                  }
                  placeholder="Nombre"
                />
              )}
            </Form.Item>
            <Form.Item style={{ width: "33.3%" }}>
              {getFieldDecorator("last_name", {
                initialValue: currentData.last_name,
                rules: [
                  {
                    required: true,
                    message: formLabelMessage("es", "required"),
                  },
                ],
              })(
                <Input
                  onChange={(e) =>
                    props.setStateForm("last_name", e.target.value)
                  }
                  maxLength={60}
                  placeholder="Apellido Paterno"
                />
              )}
            </Form.Item>
            <Form.Item style={{ width: "33.3%" }}>
              {getFieldDecorator("second_last_name", {
                initialValue: currentData.second_last_name,
              })(
                <Input
                  onChange={(e) =>
                    props.setStateForm("second_last_name", e.target.value)
                  }
                  maxLength={60}
                  placeholder="Apellido Materno"
                />
              )}
            </Form.Item>
          </Input.Group>
        </div>
      </div>
    </Fragment>
  )
}

SectionTwoManduUser.propTypes = {
  currentData: PropTypes.object,
  form: PropTypes.object,
  setStateForm: PropTypes.func,
}

export default SectionTwoManduUser
